export const getTableSize = () => {
    return `${servObj.tableSize.tableWidth.current}x${servObj.tableSize.tableDepth.current}`;
};
